import React from 'react'
import ReactMarkdown from 'react-markdown'
import classNames from 'classnames'
import { Section } from '../../../../index'

const WhyMobile = ({ content: { markdown, metadata } }) => (
  <Section
    className={classNames('why-mobile', metadata ? metadata.className : '')}
    innerClassName="why-mobile__wrapper"
    isCentered
  >
    <section className="why-mobile__content">
      <ReactMarkdown escapeHtml={false} source={markdown.content} />
    </section>
  </Section>
)

export default WhyMobile
